import { render } from "./PrivacyPolicy.vue?vue&type=template&id=e1256618&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=e1256618&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1256618"]])

export default __exports__